import { toApiDate } from './enrollDates';

export type PublicEnrollmentGuardian = { firstName?: string; lastName?: string; email?: string; phone?: string };

export type PublicEnrollmentChild = {
  id?: string;
  firstName: string;
  lastName: string;
  birthday: string;
  startDate: string;
  classTypeId: string;
  classId?: string;
  promoCodeId?: string;
};

export type PublicEnrollmentContext = {
  schoolId: string;
  enrollmentToken?: string;
  code?: string | null;
  child: PublicEnrollmentChild;
  firstKidsId?: string;
};

export const buildPublicEnrollmentPayload = (
  guardian: PublicEnrollmentGuardian,
  isFirstGuardian: boolean,
  context: PublicEnrollmentContext,
) => ({
  firstName: guardian?.firstName || '',
  lastName: guardian?.lastName || '',
  email: guardian?.email || '',
  phone: guardian?.phone || '',
  schoolId: context.schoolId,
  enrollmentToken: context.enrollmentToken || undefined,
  code: context.code || undefined,
  kids: isFirstGuardian
    ? [
        {
          id: context.child.id || undefined,
          firstName: context.child.firstName,
          lastName: context.child.lastName,
          birthday: toApiDate(context.child.birthday),
          potentialDate: toApiDate(context.child.startDate),
          classTypeId: context.child.classTypeId,
          classId: context.child.classId || undefined,
          promoCodeId: context.child.promoCodeId,
        },
      ]
    : [],
  kidsId: isFirstGuardian ? undefined : context.firstKidsId,
});
